export default {
  vidoe: {
    templatesLayout: ['layout-vertical'],
    sectionBackground: false,
    headers: {
      class: 'title h3-md',
      tag: 'h4'
    },
    cards: {
      'Grid': 'Card',
      'Slider': 'Card',
      'Slider': 'Card',
      'player': 'Card'
    },
    menu: {
      accessLink: {url: '/guest/login', title: 'Login', icon: 'fas fa-fw fa-user'},
      homeLink: {url: '/', title: 'Home', icon: 'fas fa-fw fa-home'},
      iconPrefix: 'fas fa-fw fa-',
      defaultIcon: 'fas fa-fw fa-home',
      icons: {
        home: 'home',
        video: 'video',
        channels: 'users',
        history: 'history',
        folder: 'folder'
      },
      titleTag: 'span',
      iconTag: 'i'
    },
    plugins: {
      'slider 3D': {
        height: 251
      }
    }
  },
  skrn: {
    templatesLayout: ['layout-vertical', 'layout-horizontal'],
    sectionBackground: true,
    headers: {
      class: 'title h3-md',
      tag: 'h5'
    },
    cards: {
      'Grid': 'Card',
      'Slider': 'Card',
      'Slider': 'Card',
      'player': 'Card'
    },
    menu: {
      accessLink: {url: '/guest/login', title: 'Login', icon: 'icon-Power-3'},
      homeLink: {url: '/', title: 'Home', icon: 'icon-Old-TV'},
      iconPrefix: '',
      defaultIcon: 'icon-Old-TV',
      icons: {
        home: 'icon-Old-TV',
        video: 'icon-Movie',
        channels: 'icon-Reel',
        history: 'icon-Movie-Ticket',
        folder: 'icon-Movie-Ticket'
      },
      titleTag: 'p',
      iconTag: 'span',
    }
  },
  pro: {
    templatesLayout: ['layout-horizontal'],
    sectionBackground: false,
    cards: {
      'Grid': 'Card',
      'Slider': 'Card',
      'Slider': 'Card',
      'player': 'Card'
    },
    headers: {
      class: 'title h3-md',
      tag: 'h2'
    }
  },
  adonis: {
    templatesLayout: ['layout-horizontal'],
    sectionBackground: true,
    headers: {
     class: 'title h3-md',
     tag: 'h2'
    },
    cards: {
      'Grid': 'Card',
      'Slider': 'Card',
      'Slider': 'Card',
      'player': 'Card'
    },
    menu: {
      accessLink: {url: '/guest/login', title: 'Login', icon: 'fas fa-fw fa-user'},
      homeLink: {url: '/', title: 'Home', icon: 'fas fa-fw fa-home'},
      iconPrefix: 'fas fa-fw fa-',
      defaultIcon: 'fas fa-fw fa-home',
      icons: {
        home: 'home',
        video: 'video',
        channels: 'users',
        history: 'history',
        folder: 'folder'
      },
      titleTag: 'span',
      iconTag: 'i'
    },
  },
  onair: {
    templatesLayout: ['layout-horizontal'],
    sectionBackground: true,
    headers: {
      class: 'qt-caption-small',
      tag: 'h5'
    },
    cards: {
      'Grid': 'Card',
      'Slider': 'Card',
      'Slider': 'Card',
      'player': 'Card'
    },
    menu: {
      accessLink: {url: '/guest/login', title: 'Login', icon: 'fas fa-fw fa-user'},
      homeLink: {url: '/', title: 'Home', icon: 'fas fa-fw fa-home'},
      iconPrefix: 'fas fa-fw fa-',
      defaultIcon: 'fas fa-fw fa-home',
      icons: {
        home: 'home',
        video: 'video',
        channels: 'users',
        history: 'history',
        folder: 'folder'
      },
      titleTag: 'span',
      iconTag: 'i'
    }
  }
}